import { featuredImages } from '@/mocks/images';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={featuredImages.hero}
          alt="Sugargoo Spreadsheet fashion product collection banner"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/25 mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
          <span className="text-xs font-medium text-background-50/90 tracking-wide">Independent Resource Hub</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
          Sugargoo Spreadsheet
          <br />
          <span className="text-accent-300">The Ultimate Product Discovery Database</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover thousands of organized Sugargoo finds, curated product spreadsheets, shopping guides, shipping information, coupon updates and expert reviews &mdash; all in one powerful resource.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            Sugargoo Spreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-base hover:bg-background-50/25 transition-all cursor-pointer whitespace-nowrap"
          >
            Buy It Now
            <i className="ri-shopping-bag-3-line"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-5 mt-10">
          {['Updated Regularly', 'Independent Resource', 'Shopping Guides', 'Product Research Database'].map((badge) => (
            <div key={badge} className="flex items-center gap-1.5 text-background-50/70 text-xs">
              <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
              <span>{badge}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}